import { SagasFactory } from '../factories/sagas.factory';
import { PlacesActions } from './places.actions';
import placesActionTypes from './places.actionTypes';
import { PlacesApi } from './places.api';

const factory = new SagasFactory('places', 'places', PlacesApi, PlacesActions, placesActionTypes);
export const PlacesSagas = factory.getSagas();
